import { SimulationFinancialsProvider } from '../../providers/SimulationFinancials/SimulationFinancialsProvider';
import SimulationFinancials from './SimulationFinancials';

const SimulationFinancialsPage = () => {
    return (
        <SimulationFinancialsProvider>
            <SimulationFinancials />
        </SimulationFinancialsProvider>
    );
};

export default SimulationFinancialsPage;
